import { createContext, useContext } from "react";

type ContextValueType = {
  scrollToTop: () => void;
};

export const LayoutContext = createContext<ContextValueType>({
  scrollToTop: () => {},
});

export function useLayout() {
  return useContext(LayoutContext);
}
